<template>
  <div style="text-align: center; height: 50px">
    <div style="display: inline-block">
      <dv-decoration-8 style="width: 780px; height: 30px" />
    </div>
    <span style="color: #9cd9fc; font-size: 2em"> 草莓产业互联网平台 </span>
    <span style="color: #9cd9fc; font-size: 1.4em">（中国长丰）</span>
    <div style="display: inline-block">
      <dv-decoration-8 :reverse="true" style="width: 780px; height: 30px" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/title-zone/index.vue